export default __webpack_public_path__ + "static/media/logo_siege_big.63be1efe.png";